import React from 'react';
import * as styles from '../index-row.styles';
import { useIndexRowItemContext } from './index-row-item';

type IndexRowHeadProps = {
  children: React.ReactNode;
};

export const IndexRowHead = ({ children }: IndexRowHeadProps) => {
  const { disabled } = useIndexRowItemContext();
  return <div className={disabled ? styles.halfOpacityStyle : undefined}>{children}</div>;
};

IndexRowHead.displayName = 'IndexRowHead';
